import React, { useEffect, useState, createElement } from 'react';
import { TrendingUp, User, X, Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { posthog } from '../lib/posthog';
declare global {
  interface Window {
    Tally?: {
      openPopup: (formId: string, options?: Record<string, any>) => void;
      closePopup: (formId: string) => void;
    };
  }
}
const EARLY_ACCESS_URL = 'https://register.gocaveo.com';
const USER_PASSWORD = 'learnpasswordcreationin2026!';
const INVESTOR_PASSWORD = 'ProtectYourFamily2026!';
function PasswordModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  description,
  icon,
  error,
  password,
  onPasswordChange
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  title: string;
  description: string;
  icon: React.ReactNode;
  error: string;
  password: string;
  onPasswordChange: (val: string) => void;
}) {
  if (!isOpen) return null;
  return <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '24px'
  }} onClick={onClose} data-id="element-1348" data-mp="1qvxojhk8vdob">
      <div style={{
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '32px',
      maxWidth: '384px',
      width: '100%',
      position: 'relative',
      boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)'
    }} onClick={e => e.stopPropagation()} data-id="element-1349" data-mp="1109lm0n7mkao">
        <button type="button" onClick={onClose} style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#9ca3af',
        padding: '4px'
      }} data-id="element-1350" data-mp="1ooswmnxn9b6g">
          <X size={20} data-id="element-1351" data-mp="8dov12ek6c86" />
        </button>

        <div style={{
        textAlign: 'center',
        marginBottom: '24px'
      }} data-id="element-1352" data-mp="9sj9wd8f9oem">
          <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: 'rgba(99,27,183,0.1)',
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px'
        }} data-id="element-1353" data-mp="eqkuj2lhxvs7">
            {icon}
          </div>
          <h2 style={{
          fontSize: '20px',
          fontWeight: 600,
          color: '#111111',
          margin: '0 0 8px 0'
        }} data-id="element-1354" data-mp="3rz61456q75oq">
            {title}
          </h2>
          <p style={{
          fontSize: '14px',
          color: '#6b7280',
          margin: 0
        }} data-id="element-1355" data-mp="3i6i4pbjnr3qj">
            {description}
          </p>
        </div>

        <form onSubmit={onSubmit} data-id="element-1356" data-mp="399zbrzbfffty">
          <input type="password" value={password} onChange={e => onPasswordChange(e.target.value)} placeholder="Enter password" autoFocus style={{
          width: '100%',
          padding: '12px 16px',
          border: '2px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '16px',
          outline: 'none',
          marginBottom: '12px',
          boxSizing: 'border-box'
        }} data-id="element-1357" data-mp="2pll20k1s0t0j" />
          {error && <p style={{
          color: '#ef4444',
          fontSize: '14px',
          marginBottom: '12px',
          marginTop: 0
        }} data-id="element-1358" data-mp="33lm5m79feejp">
              {error}
            </p>}
          <button type="submit" style={{
          width: '100%',
          backgroundColor: '#631bb7',
          color: '#fff',
          padding: '12px',
          borderRadius: '8px',
          fontWeight: 700,
          fontSize: '16px',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-1359" data-mp="3raov21aaxbor">
            Log In
          </button>
        </form>
      </div>
    </div>;
}
export function ComingSoonPage() {
  const navigate = useNavigate();
  const [userModal, setUserModal] = useState(false);
  const [userPassword, setUserPassword] = useState('');
  const [userError, setUserError] = useState('');
  const [investorModal, setInvestorModal] = useState(false);
  const [investorPassword, setInvestorPassword] = useState('');
  const [investorError, setInvestorError] = useState('');
  // Load Tally embed script
  useEffect(() => {
    if (window.Tally) {
      return;
    }
    const existingScript = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
    if (existingScript) {
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);
  // Listen for Tally form submissions and track them in PostHog
  useEffect(() => {
    const handleTallyMessage = (e: MessageEvent) => {
      const data = e.data;
      let parsed: any = data;
      if (typeof data === 'string') {
        try {
          parsed = JSON.parse(data);
        } catch {
          // Some Tally messages aren't JSON — bail out quietly
          return;
        }
      }
      if (parsed && typeof parsed === 'object' && parsed.event === 'Tally.FormSubmitted') {
        const formId = parsed.formId || parsed.payload?.formId;
        if (formId === '2E4rjD') {
          posthog.capture?.('waitlist_submitted', {
            source: 'coming_soon_page',
            form_id: formId,
            form_name: 'early_access_waitlist'
          });
        }
      }
    };
    window.addEventListener('message', handleTallyMessage);
    return () => window.removeEventListener('message', handleTallyMessage);
  }, []);
  const openEarlyAccessForm = () => {
    posthog.capture?.('waitlist_opened', {
      source: 'coming_soon_page',
      form_name: 'early_access_waitlist'
    });
    if (window.Tally) {
      window.Tally.openPopup('2E4rjD', {
        layout: 'modal',
        width: 700,
        autoClose: 5000
      });
    } else {
      // Retry after a short delay in case script is still loading
      setTimeout(() => {
        if (window.Tally) {
          window.Tally.openPopup('2E4rjD', {
            layout: 'modal',
            width: 700,
            autoClose: 5000
          });
        } else {
          window.open('https://tally.so/r/2E4rjD', '_blank');
        }
      }, 500);
    }
  };
  const handleUserSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userPassword === USER_PASSWORD) {
      navigate('/home');
    } else {
      setUserError('Incorrect password. Please try again.');
      setUserPassword('');
    }
  };
  const handleInvestorSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (investorPassword === INVESTOR_PASSWORD) {
      navigate('/investor-portal');
    } else {
      setInvestorError('Incorrect password. Please try again.');
      setInvestorPassword('');
    }
  };
  const openInvestorModal = () => {
    setInvestorModal(true);
    setInvestorError('');
    setInvestorPassword('');
  };
  const openUserModal = () => {
    setUserModal(true);
    setUserError('');
    setUserPassword('');
  };
  const btnStyle = {
    boxShadow: '0 2px 6px 0 rgba(97,28,183,0.35)',
    width: '190px',
    backgroundColor: '#611CB7',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
    padding: '8px 12px',
    whiteSpace: 'nowrap' as const
  };
  return <div className="w-full min-h-screen bg-white flex flex-col font-inter" data-id="element-1360" data-mp="3loe04zi7ecr9">
      <div className="flex-grow flex items-center justify-center px-6 py-8 md:py-16" data-id="element-1361" data-mp="3gqw05ym5z7ve">
        <div className="max-w-2xl mx-auto text-center w-full" data-id="element-1362" data-mp="2w4sj24ilzutf">
          {/* Logo */}
          <div className="mb-5 md:mb-10" data-id="element-1363" data-mp="3064cym8in27f">
            <img src="https://cdn.magicpatterns.com/uploads/cd519Db2szcZYHb21ayY7p/Digital_Logo.gif" alt="Caveo Logo" className="h-10 md:h-12 mx-auto" data-id="element-1364" data-mp="3075n8ohpjko3" />
          </div>

          {/* Coming Soon pill */}
          <span className="inline-flex items-center gap-1.5 border border-gray-200 text-gray-500 px-4 py-1.5 rounded-full text-sm font-medium mb-4 md:mb-8" style={{
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
        }} data-id="element-1365" data-mp="3f3d8zt8rku5h">
            Coming Soon
          </span>

          {/* Headline */}
          <h1 className="text-[2rem] md:text-[3.125rem] font-semibold leading-[1.15] tracking-tight mb-4 md:mb-6" data-id="element-1366" data-mp="3stqgxvlno8ut">
            <div className="text-[38px] text-[#3D3D3D]" data-id="element-1367" data-mp="1q1s4cehebs1">
              Businesses Have Security Teams.
            </div>
            <div className="text-[38px] text-[#611CB7]" data-id="element-1368" data-mp="6lh3mxp0nvla">
              Families Have Caveo.
            </div>
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-gray-500 leading-relaxed mb-5 md:mb-8 max-w-xl mx-auto px-5 font-[400]" data-id="element-1369" data-mp="1m69ixebcpwlu">
            The protections that stop scams and fraud already exist. Caveo helps
            your household get them done, and keep them done.
          </p>

          {/* Social proof */}
          <div className="flex items-center justify-center gap-2 mb-5 md:mb-8 flex-wrap" data-id="element-1370" data-mp="29usj16k8z32u">
            <div className="flex -space-x-1.5" data-id="element-1371" data-mp="24y24wos06hk2">
              <img src="https://cdn.magicpatterns.com/uploads/hWaiuybttDtKRteuKPKNbJ/Lois.png" alt="Lois Phillips" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1372" data-mp="24zd8anhjdnan" />
              <img src="https://cdn.magicpatterns.com/uploads/682socyzJ4p4MN22Z36zwX/Leslie.png" alt="Leslie Phillips" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1373" data-mp="2snmz63tlx18n" />
              <img src="https://cdn.magicpatterns.com/uploads/uPMm8oG7WLvjmE4PY4hoNN/Daniel.png" alt="Daniel Phillips" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1374" data-mp="p223j79kx3ge" />
              <img src="https://cdn.magicpatterns.com/uploads/jcVdYUkevvbrVPtMtUpoad/Lisa_Headshot.png" alt="Lisa Phillips" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1375" data-mp="tyacg2x6o0f4" />
              <img src="https://cdn.magicpatterns.com/uploads/w4oRMBG6uCTJ2Pvy22jWW2/Phillips_Headshot_Transparent_Rounded.png" alt="Phillips family member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1376" data-mp="1howm1ymu5sr8" />
            </div>
            <p className="text-xs text-gray-500" data-id="element-1377" data-mp="1mo98wjdpiztt">
              Built with the Brady Phillips family.
            </p>
          </div>

          {/* Launch note (temporarily replaces the early access button) */}
          <p className="text-sm font-semibold text-[#611CB7]" data-id="element-1378" data-mp="2abwdl6u4vqkd">
            Early access opens soon.
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="py-6 text-center text-sm text-gray-400" data-id="element-1379" data-mp="1wdpnicvfeuv9">
        © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
      </div>

      <PasswordModal isOpen={userModal} onClose={() => setUserModal(false)} onSubmit={handleUserSubmit} title="User Access" description="Enter your password to continue." icon={<Lock size={22} color="#631bb7" data-id="element-1381" data-mp="1dm6lo9d51mut" />} error={userError} password={userPassword} onPasswordChange={val => {
      setUserPassword(val);
      setUserError('');
    }} data-id="element-1380" data-mp="1mla2t7sqvs6o" />

      <PasswordModal isOpen={investorModal} onClose={() => setInvestorModal(false)} onSubmit={handleInvestorSubmit} title="Investor Access" description="Enter your password to view the investor deck." icon={<TrendingUp size={22} color="#631bb7" data-id="element-1383" data-mp="kqp62pqps66e" />} error={investorError} password={investorPassword} onPasswordChange={val => {
      setInvestorPassword(val);
      setInvestorError('');
    }} data-id="element-1382" data-mp="13o905tmny45w" />
    </div>;
}